import { makeStyles } from '@material-ui/core';
import Button from '@eduzz/houston-ui/Button';
import { CourseTheme } from 'assets/themes/Course';
import FieldText from '@eduzz/houston-ui/Forms/Text';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles<CourseTheme>((theme) => ({
  button: {
    background: `${theme.palette.grey[500]} !important`,
    color: `${theme.palette.common.white} !important`,
    '&:hover, &:disabled': {
      background: `${theme.palette.grey[600]} !important`,
      maxWidth: 120,
    },
    maxWidth: 100,
  },
  input: {
    '& label': {
      fontWeight: 600,
      color: `${theme.palette.grey[500]} !important`,
    },
    '& Mui-focused': {
      color: `${theme.palette.grey[500]} !important`,
    },
    '& fieldset': {
      borderColor: `${theme.palette.grey[300]} !important`,
    },
    '& > textarea': {
      color: theme.variables.courseTheme.text,
      borderRadius: theme.shape.borderRadius,
    },
    '& .Mui-disabled': {
      background: 'none',
      color: theme.palette.grey[300],
    },
    '& .houston-icon': {
      color: theme.palette.common.white,
    },
  },
  form: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
  },
}));

const validationSchema = yup.object({
  comment: yup
    .string()
    .max(2500, 'O comentário só pode conter no máximo 2500 caracteres')
    .required('Você precisa esrever um comentário para comentar'),
});

interface IProps {
  onSubmit: (lessonId: number, text: string) => Promise<void>;
}

const MakeComment = (props: IProps) => {
  const { lessonID } = useParams<{ lessonID: string }>();
  const classes = useStyles();

  const formik = useFormik({
    initialValues: {
      comment: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: ({ comment }) => {
      props.onSubmit(parseInt(lessonID), comment).finally(() => {
        formik.setSubmitting(false);
        formik.values.comment = '';
      });
    },
  });

  return (
    <form
      aria-label='formulário para a escrita de um comentário'
      className={classes.form}
      onSubmit={formik.handleSubmit}
    >
      <FieldText
        aria-label='Campo para escrita de um comentário para a aula'
        fullWidth
        type='text'
        value={formik.values.comment}
        name='comment'
        className={classes.input}
        errorMessage={formik.errors.comment}
        placeholder='Adicionar comentário...'
        disabled={formik.isSubmitting}
        multiline={true}
        onChange={formik.handleChange('comment')}
        id='lesson-form-comments'
      />
      <Button
        aria-label='botão enviar comentário'
        className={classes.button}
        variant='contained'
        type='submit'
        loading={formik.isSubmitting}
        id='lesson-comment-btn-submit'
      >
        Comentar
      </Button>
    </form>
  );
};

export default MakeComment;
